import ExtractManagementLayout from './ExtractManagementLayout';

export default ExtractManagementLayout;
